import styled from 'styled-components';
import Color from 'octa-front-sdk/dist/enums/Color';
import { MediaQuery } from 'octa-front-sdk';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';
import {
  GroupedListContainer,
  GroupedListContent,
  GroupedListHeaderContainer,
} from 'octa-front-sdk/dist/components/GroupedList/styles';

const Container = styled.div`
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  max-width: 800px;

  ${MediaQuery.BiggerThanSmall} {
    margin: 0 auto;
  }

  ${GroupedListContainer} {
    ${GroupedListHeaderContainer} {
      background-color: initial;
      margin-bottom: 20px;
      color: ${Color.Grey900};
      padding: 0;
      font-size: ${FontSize.Big};

      ${MediaQuery.BiggerThanSmall} {
        margin-bottom: 30px;
      }
    }

    & > div:nth-child(1n + 2) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      margin-bottom: 20px;
    }

    ${GroupedListContent} {
      min-width: 280px;
      width: 100%;
      display: flex;
      flex: 1;
      justify-content: space-between;
      box-sizing: border-box;
      border: 1px solid ${Color.Grey300};
      border-radius: 5px;
      margin-bottom: 20px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: transform 300ms ease;

      &:hover {
        transform: scale(1.05);
      }

      ${MediaQuery.BiggerThanSmall} {
        flex: 1;
        margin-bottom: 5%;
        height: auto;
      }

      @media (min-width: 600px) {
        min-width: 260px;
        max-width: 47.5%;

        &:nth-child(2n) {
          margin-left: 5%;
        }
      }
    }
  }
`;

const DishesStyles = {
  Container,
};

export default DishesStyles;
